/**
 * Great-circle distance between two `{lat, lng}` points, in statute miles.
 *
 * Pure function. No Google Maps dependency so it is safe to use in the
 * Vuex store, services, SSR, and unit tests.
 *
 * Earth radius is the mean radius (3963.0 miles) used by the legacy
 * location-bounds math. Keeping the same constant means the new helper
 * produces identical results to the inline math it replaced.
 */
const EARTH_RADIUS_MILES = 3963.0
const DEGREES_PER_RADIAN = 57.29577951308232

function toRadians(degrees) {
  return degrees / DEGREES_PER_RADIAN
}

// eslint-disable-next-line import/prefer-default-export
export function distanceMiles(a, b) {
  if (!a || !b
    || !Number.isFinite(a.lat) || !Number.isFinite(a.lng)
    || !Number.isFinite(b.lat) || !Number.isFinite(b.lng)) {
    return 0
  }

  const lat1 = toRadians(a.lat)
  const lng1 = toRadians(a.lng)
  const lat2 = toRadians(b.lat)
  const lng2 = toRadians(b.lng)

  const cosine = Math.sin(lat1) * Math.sin(lat2)
    + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1)

  // Math.acos is undefined just outside [-1, 1]; floating-point drift on
  // identical points can push the dot product to 1.0000000002, so clamp.
  const clamped = Math.max(-1, Math.min(1, cosine))

  return EARTH_RADIUS_MILES * Math.acos(clamped)
}
